<section class="brand-sec space-top w-100 mb-5" id="brand-sec">
    <div class="container th-container4 mt-auto mt-lg-5">
        <div class="swiper th-slider w-100 brandSlider1" id="brandSlider1"
            data-slider-options='{"breakpoints":{"0":{"slidesPerView":1},"576":{"slidesPerView":"2"},"768":{"slidesPerView":"3"},"992":{"slidesPerView":"3"},"1300":{"slidesPerView":"6"},"1400":{"slidesPerView":"7"}}}'>
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/amazio.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/amazio.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/quickcarsale.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/quickcarsale.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/prpool.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/prpool.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/optikschlemmer.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/optikschlemmer.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/coir-america-medium.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/coir-america-medium.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/dault-law-medium.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/dault-law-medium.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/ecotrak.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/ecotrak.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/fms-medium.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/fms-medium.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/i2rPortal.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/i2rPortal.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/income-property-showcase-medium.png"
                                alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/income-property-showcase-medium.png"
                                alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/jdp-medium.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/jdp-medium.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/kamilha.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/kamilha.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/lets-talk-dirty-app-medium.png"
                                alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/lets-talk-dirty-app-medium.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/logo-1-1-medium.jpg" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/logo-1-1-medium.jpg" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/logo-2-1-medium.jpg" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/logo-2-1-medium.jpg" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/logo-3-1-medium.jpg" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/logo-3-1-medium.jpg" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/logo-4-1-medium.jpg" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/logo-4-1-medium.jpg" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/tcmcapital.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/tcmcapital.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/weareallelemental.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/weareallelemental.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="brand-box">
                        <a href="javascript:void(0);">
                            <img class="original" src="assets/img/brand/weteach.png" alt="Brand Logo">
                            <img class="gray" src="assets/img/brand/weteach.png" alt="Brand Logo">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>